import { Component, signal } from '@angular/core';
import { BSharedServiceService } from '../../../Services/BService/b-shared-service.service';
import { BServiceService } from '../../../Services/BService/b-service.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-b-first-selection',
  templateUrl: './b-first-selection.component.html',
  styleUrl: './b-first-selection.component.css'
})
export class BFirstSelectionComponent {
  scrollToCommonSecondComponent() {
    const hpSecondComponent = document.querySelector('app-second-selection');
    if (hpSecondComponent) {
      hpSecondComponent.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
  signalStatus:boolean=false;
  panelOpenState = signal(this.signalStatus);
  specData:any={};
  userSelectedData:any={};
  modifiedSize:any;
  sizeSpeedRatio:any={
    size:"",
      ratio:"",
      speed:"",
      inputPower:"",
      units:""
  };
  public showspinfo: boolean = false;
  public showcdinfo: boolean = false;
constructor(private bSharedService:BSharedServiceService, private bService:BServiceService,private router:Router){}
ngOnInit(){
  const currentUrl = window.location.href.toLowerCase();
  if (currentUrl.includes('spineatools') ) {
      this.showspinfo = true;
      this.showcdinfo = false;
    } else {
      this.showspinfo = false;
      this.showcdinfo = true;
    }
  this.signalStatus=true;
    this.panelOpenState = signal(this.signalStatus);
  this.bSharedService.specification$.subscribe((specificationData:any) => 
    {
      this.sizeSpeedRatio.size = specificationData.UnitDesignation;
      this.sizeSpeedRatio.ratio = specificationData.NominalRatio;
      this.sizeSpeedRatio.speed = specificationData.InputSpeed;
      this.specData={
        Effieciency:specificationData.Effieciency=="N/A"?specificationData.Effieciency:specificationData.Effieciency +" %",
        InputPowerMech:specificationData.InputPowerMech=="N/A"?specificationData.InputPowerMech :specificationData.InputPowerMech+ " HP",
        InputPowerTherm:specificationData.InputPowerTherm == "N/A"?specificationData.InputPowerTherm :specificationData.InputPowerTherm+ " HP",
        InputSpeed:specificationData.InputSpeed,
        NominalRatio:specificationData.NominalRatio,
        OutputSpeed:specificationData.OutputSpeed,
        OutputTorque:specificationData.OutputTorque=="N/A"?specificationData.OutputTorque:specificationData.OutputTorque+" lb-in",
        PowerType:specificationData.PowerType,
        Series:specificationData.Series,
        UnitDesignation:specificationData.UnitDesignation,
        specServiceFactor:specificationData.specServiceFactor,
        InputPowerMech_Met: specificationData.InputPowerMech_Met=="N/A"?specificationData.InputPowerMech_Met:specificationData.InputPowerMech_Met+" kW",
        InputTorque_Imp: specificationData.InputTorque_Imp=="N/A"?specificationData.InputTorque_Imp:specificationData.InputTorque_Imp+" lb-in",
        InputTorque_Met:specificationData.InputTorque_Met=="N/A"?specificationData.InputTorque_Met:specificationData.InputTorque_Met+" Nm",
        InputTorqueAccel_Imp: specificationData.InputTorqueAccel_Imp=="N/A"?specificationData.InputTorqueAccel_Imp: specificationData.InputTorqueAccel_Imp+" lb-in",
        InputTorqueAccel_Met: specificationData.InputTorqueAccel_Met=="N/A"?specificationData.InputTorqueAccel_Met:specificationData.InputTorqueAccel_Met+" Nm",
        InputPowerThermal_Met: specificationData.InputPowerThermal_Met =="N/A"?specificationData.InputPowerThermal_Met:specificationData.InputPowerThermal_Met+ " kW",
        OutputTorque_Met: specificationData.OutputTorque_Met=="N/A"?specificationData.OutputTorque_Met:specificationData.OutputTorque_Met+" Nm",
        OutputTorqueAccel_Imp: specificationData.OutputTorqueAccel_Imp=="N/A"?specificationData.OutputTorqueAccel_Imp:specificationData.OutputTorqueAccel_Imp+" lb-in",
        OutputTorqueAccel_Met: specificationData.OutputTorqueAccel_Met=="N/A"?specificationData.OutputTorqueAccel_Met:specificationData.OutputTorqueAccel_Met+" Nm"
      };
      this.modifiedSize = this.specData.UnitDesignation.substring(1,3);
      const specSFElements = document.getElementsByClassName('sericeFactorStyle');
for (let i = 0; i < specSFElements.length; i++) {
  const element = specSFElements[i] as HTMLElement;
  if (Number(specificationData.specServiceFactor) < Number(this.userSelectedData.SelectedServiceFactor)) {
      element.style.setProperty('background-color', '#dc3545', 'important');
  } else {
      element.style.setProperty('background-color', '#28a745', 'important');
  }
}
    });
    this.bSharedService.getFormData().subscribe(data => {
      this.sizeSpeedRatio.inputPower = data.selectedInputPower;
      this.sizeSpeedRatio.units = data.selectedUnits;
      this.userSelectedData={
        SelectedInputPower:data.selectedInputPower || "Null",
        SelectedUnits:data.selectedUnits || "Null",
        SelectedSpeed:data.selectedSpeed || "Null",
        SelectedRatio:data.selectedRatio || "Null",
        SelectedDutyCycle:data.selectedDutyCycle || "Null",
        SelectedServiceFactor:data.selectedServiceFactor || "Null",
        SelectedOutputSpeed:data.selectedOutputSpeed || "Null"
      };
    });
}
largerReducer():void{
  const parameters={
    size:this.sizeSpeedRatio.size,
    speed:this.sizeSpeedRatio.speed,
    ratio:this.sizeSpeedRatio.ratio,
    Inputpower_Them : this.sizeSpeedRatio.inputPower,
    units: this.sizeSpeedRatio.units
  };
  this.bService.getLargerReducer(parameters).subscribe(result => {
    debugger;
        if(result.body==null){
      alert("No Larger Size available")
    }else
    {
      this.bSharedService.setSpecification(result.body);
    }
  });

}
smallerReducer():void{
  const parameters={
    size:this.sizeSpeedRatio.size,
    speed:this.sizeSpeedRatio.speed,
    ratio:this.sizeSpeedRatio.ratio,
    Inputpower_Them : this.sizeSpeedRatio.inputPower,
    units: this.sizeSpeedRatio.units
  };
  this.bService.getSmallerReducer(parameters).subscribe(result => {
    if(result.body==null){
      alert("No Smaller Size available")
    }else
    {
      this.bSharedService.setSpecification(result.body);
    }
  });

}
reducerFeature():void{
  this.bSharedService.setSize(this.sizeSpeedRatio);
}
}
